export default __webpack_public_path__ + "static/media/3.b23e590e.jpg";